module.exports = __webpack_public_path__ + "media/Verizon_Bethesda_200113B_720p_1mbps.mp4";